export const INTEGRATIONS_QUERY = 'integrations';
export const INTEGRATIONS_HISTORY_QUERY = 'run-history';
export const INTEGRATIONS_API_URL = process.env.REACT_APP_API_SERVICE_URL;
export const DATA_SOURCE_QUERY = 'data-source';
